import { Block } from './block';
import { Blocks } from '../constants/blocks';
import { Translation } from './translation';
import { Translations } from '../constants/translations';
import { ContentCard } from './contentCard';
import { useTranslation } from '../hooks/useTranslation';

export const LearnMoreCard = () => {
  const learnMoreLink = useTranslation(Translations.learn_more_link);

  return (
    <ContentCard
      noHeader
      className={`contentCard_content`}
      label={<Block k={Blocks.learn_more} />}
    >
      <div className="actionGroup">
        <a href={learnMoreLink} className="button">
          <span className="button__label">
            <Translation k={Translations.learn_more} />
          </span>
          <span className="button__icon">
            <svg
              width="24"
              height="24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.92 11.62a1.001 1.001 0 00-.21-.33l-5-5a1.003 1.003 0 10-1.42 1.42l3.3 3.29H7a1 1 0 000 2h7.59l-3.3 3.29a1.001 1.001 0 00.325 1.639 1 1 0 001.095-.22l5-5a1 1 0 00.21-.33 1 1 0 000-.76z"
                fill="#000"
              />
            </svg>
          </span>
        </a>
      </div>
    </ContentCard>
  );
};
